// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"271":"a0481aff","351":"ee39c28a","661":"7e3b0d08"}[chunkId] + ".chunk.css";
};